import React from 'react';
import { PlayIcon } from 'lucide-react';
import { screenshots } from '../data/screenshots';
interface MediaPlaceholderProps {
  /** Names the exact screenshot that belongs in this slot. */
  label: string;
}
export function MediaPlaceholder({
  label
}: MediaPlaceholderProps) {
  const image = screenshots[label];
  if (image) {
    return <figure className="overflow-hidden rounded-xl border border-white/10 bg-black/40" data-id="element-48" data-mp="1dgbe0turhz4s">
        <div className="flex aspect-video w-full items-center justify-center p-3 sm:p-4" data-id="element-49" data-mp="fuvuw1ycco4z">
          <img src={image} alt={label} loading="lazy" className="h-full w-full rounded-lg object-contain" data-id="element-50" data-mp="kt772jc3zaqd" />
        </div>
        <figcaption className="border-t border-white/10 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.18em] text-white/60" data-id="element-51" data-mp="uqvby23fhym9">
          {label}
        </figcaption>
      </figure>;
  }
  return <div role="img" aria-label={`Media placeholder: ${label} — coming soon`} className="group/media relative flex aspect-video w-full flex-col items-center justify-center gap-3.5 overflow-hidden rounded-xl border border-dashed border-white/20 bg-black/40 px-5 text-center" data-id="element-52" data-mp="264pedg9bp7ji">
      <span className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_70%_at_50%_45%,rgba(16,185,129,0.12),transparent_70%)]" data-id="element-53" data-mp="96znp3xrzdlt" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#10b981]/40 bg-[#10b981]/10 text-[#10b981] transition-transform duration-200 group-hover/media:scale-105" data-id="element-54" data-mp="4b250qz1hv5v">
        <PlayIcon className="h-5 w-5 translate-x-[1px] fill-[#10b981]" aria-hidden="true" data-id="element-55" data-mp="3qmpkox4cehmu" />
      </span>
      <span className="relative font-mono text-[12.5px] font-semibold tracking-tight text-white sm:text-sm" data-id="element-56" data-mp="3hnugfqkuzhm6">
        {label}
      </span>
      <span className="relative font-mono text-[10px] uppercase tracking-[0.22em] text-white/50" data-id="element-57" data-mp="3cnpwtronm6rq">
        Screenshot — coming soon
      </span>
    </div>;
}